export default __webpack_public_path__ + "static/media/img_base_green_p.5fdc2df9.jpg";